import { isValidBaseUrl, resolveApp } from '#route-map/match'
import { Middleware } from '@nuxt/types'

const crossAppRouter: Middleware = ({ next, route, $config }) => {
  if (!process.client) return

  const webBaseUrl = $config.webAppBaseUrl
  if (!webBaseUrl || !isValidBaseUrl(webBaseUrl)) return

  const targetApp = resolveApp(route.path)

  if (targetApp === 'web') {
    const url = new URL(route.fullPath, webBaseUrl)
    window.location.href = url.href

    // abort other middlewares
    next?.(false)
  }
}

export default crossAppRouter
